// extracted by mini-css-extract-plugin
export var active = "Tooltip-module--active--36092";
export var button = "Tooltip-module--button--e87a2";
export var content = "Tooltip-module--content--e6fe4";
export var icon = "Tooltip-module--icon--e7991";
export var tooltip = "Tooltip-module--tooltip--28df4";